import { Card, Divider, Grid } from '@material-ui/core';
import { CatalogueType } from 'api/query/catalogue';
import { PedigreeVisibility } from 'api/query/shared/pedigree-visibility-enum';
import AnimalIdLink from 'components/animal-id-link';
import { AnimalTags } from 'components/animal-tags/animal-tags';
import { MiniTable } from 'components/table/mini-table/mini-table';
import { useResults } from 'pages/shared/use-results';
import React from 'react';
import { AnimalCardProps } from './animal-card-props';
import './animal-card.scss';

/**
 * Animal Card
 */
export const AnimalCard: React.FC<AnimalCardProps> = (props) => {
  const {
    customASBVs,
    topPercentile,
    bottomPercentile,
  } = useResults();

  const labels: string[] = ['trait', 'asbv', 'acc.', 'pctl.'];

  // Format a full LPID to have - in-between FlockCode, Drop, AnimalID
  const formatAnimalID = (fullAnimalId: string) => {
    if (fullAnimalId) {
      const flockCode: String = fullAnimalId.substring(0, 6);
      const drop: String = fullAnimalId.substring(6, 10);
      const animalId: String = fullAnimalId.substring(10);
      return `${flockCode}-${drop}-${animalId}`;
    }
    return 'Unavailable';
  };

  return (
    <Card className={`sg-animal-card  ${props.isCatalogue ? 'sg-catalogue-animal-card' : ''}`}>
      {props.isCatalogue && (
        <>
          <div className="sg-animal-card__header">
            {props.type === CatalogueType.Sales ? (
              <Grid
                item
                xs={8}
                className="sg-animal-card__header__lot"
              >
                <div className="sg-animal-card__header__title">Lot</div>
                <div>{props.lot}</div>
              </Grid>
            ) : (
              <Grid
                item
                xs={8}
                className="sg-animal-card__header__lot"
              >
                <div className="sg-animal-card__header__title">Doses</div>
                <div>{props.dose}</div>
              </Grid>
            )}
            {props.displayPrice && (
              <Grid
                item
                xs={4}
                className="sg-animal-card__header__price"
              >
                <div className="sg-animal-card__header__title">Price</div>
                <div>{props.price}</div>
              </Grid>
            )}
          </div>
          <Divider variant="fullWidth" />
        </>
      )}
      <AnimalIdLink
        id={props.animal.animalId}
        label={props.animal.studId}
        asbvs={customASBVs}
        database={props.db}
        trait={props.trait}
        bold={false}
      />
      <div className="sg-animal-card__tags"><AnimalTags animal={props.animal} /></div>

      <div className="sg-animal-card__parent-animals">
        <div>
          <span
            className="MuiTypography-colorPrimary"
            style={{ fontWeight: 'bold' }}
          >Sire:
          </span>
          {props.animal.sireVisibility === PedigreeVisibility.VisibleWithLink
            ? (
              <AnimalIdLink
                id={props.animal.sireAnimalId}
                label={formatAnimalID(props.animal.sireAnimalId)}
                database={props.db}
                trait={props.trait}
                asbvs={customASBVs}
                bold={false}
              />
            )
            : (formatAnimalID(props.animal.sireAnimalId))}
        </div>
        <div>
          <span
            className="MuiTypography-colorPrimary"
            style={{ fontWeight: 'bold' }}
          >Dam:
          </span>
          {props.animal.damVisibility === PedigreeVisibility.VisibleWithLink
            ? (
              <AnimalIdLink
                id={props.animal.damAnimalId}
                label={formatAnimalID(props.animal.damAnimalId)}
                database={props.db}
                trait={props.trait}
                asbvs={customASBVs}
                bold={false}
              />
            )
            : (formatAnimalID(props.animal.damAnimalId))}
        </div>
      </div>

      <div>
        <MiniTable
          headerLabels={labels}
          traits={props.animal.asbvs}
          percentileHighlights={{ top: topPercentile, bottom: bottomPercentile }}
          showTraitColumn
        />
      </div>
    </Card>
  );
};

// (AnimalCard as any).whyDidYouRender = {
//   customName: 'AnimalCard',
// };
